import React from 'react';
import { getInitials, getInitialsColor } from '../utils/initials';

interface ProfileAvatarProps {
  src?: string | null;
  username: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  onClick?: () => void;
}

const sizeClasses = {
  sm: 'w-10 h-10 text-sm',
  md: 'w-12 h-12 text-base',
  lg: 'w-14 h-14 text-lg',
  xl: 'w-32 h-32 text-4xl'
};

export function ProfileAvatar({ src, username, size = 'md', onClick }: ProfileAvatarProps) {
  const initials = getInitials(username);
  const colorClasses = getInitialsColor(username);
  const sizeClass = sizeClasses[size];

  if (src) {
    return (
      <img
        src={src}
        alt={username}
        className={`${sizeClass} rounded-full object-cover ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
        onClick={onClick}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} ${colorClasses} rounded-full flex items-center justify-center font-semibold ${
        onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''
      }`}
      onClick={onClick}
    >
      {initials}
    </div>
  );
}